"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationsForm = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var styles = __importStar(require("./AutomationsForm.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var lodash_2 = require("lodash");
var classnames_1 = __importDefault(require("classnames"));
var MAX_NUM_ACTIONS = 3;
var AutomationsForm = function (props) {
    var _a;
    var triggersAndActions = props.triggersAndActions, integrationTarget = props.integrationTarget, currentAutomation = props.currentAutomation, onAutomationChange = props.onAutomationChange;
    var _b = __read((0, react_1.useState)(currentAutomation ? currentAutomation.triggerId : undefined), 2), selectedTrigger = _b[0], setTrigger = _b[1];
    var mapSelectedActions = function () {
        var mappedActions = [];
        if (currentAutomation.actions.length > 0) {
            currentAutomation.actions.forEach(function (currentAction) {
                var foundAction = triggersAndActions.actions.find(function (action) { return action.id == currentAction.actionId; });
                if (foundAction)
                    mappedActions.push(__assign(__assign({}, foundAction), { selectedOptions: currentAction.selectedOptions }));
            });
            return mappedActions;
        }
        else
            return createEmptySelectedActions();
    };
    var _c = __read((0, react_1.useState)(mapSelectedActions()), 2), selectedActions = _c[0], setActionSelections = _c[1];
    var Icon = (integrationTarget.integrationName && icons[(0, lodash_2.capitalize)(integrationTarget.integrationName)]) || icons.Tokens;
    var selectTrigger = function (trigger) {
        setTrigger(trigger.id);
        setActionSelections(createEmptySelectedActions());
        onAutomationChange(__assign(__assign({}, currentAutomation), { triggerId: trigger.id, actions: [] }));
    };
    var selectAction = function (action, index) {
        var newSelectedActions = __spreadArray(__spreadArray(__spreadArray([], __read(selectedActions.slice(0, index)), false), [
            __assign(__assign({}, action), { selectedOptions: action.form
                    ? action.form.reduce(function (result, formField) {
                        var _a;
                        return formField.options.length === 1 ? __assign(__assign({}, result), (_a = {}, _a[formField.name] = formField.options[0].id, _a)) : result;
                    }, {})
                    : {} })
        ], false), __read(selectedActions.slice(index + 1)), false);
        setActionSelections(newSelectedActions);
        onAutomationChange(__assign(__assign({}, currentAutomation), { actions: newSelectedActions.map(function (selection) {
                return { actionId: selection.id, selectedOptions: selection.selectedOptions };
            }) }));
    };
    var addNewAction = function (action) {
        var newSelectedActions = __spreadArray(__spreadArray([], __read(selectedActions), false), [__assign(__assign({}, action), { selectedOptions: {} })], false);
        setActionSelections(newSelectedActions);
        onAutomationChange(__assign(__assign({}, currentAutomation), { actions: newSelectedActions.map(function (selection) {
                return { actionId: selection.id, selectedOptions: selection.selectedOptions };
            }) }));
    };
    var deleteAction = function (index) {
        var newSelectedActions = __spreadArray(__spreadArray([], __read(selectedActions.slice(0, index)), false), __read(selectedActions.slice(index + 1)), false);
        setActionSelections(newSelectedActions);
        onAutomationChange(__assign(__assign({}, currentAutomation), { actions: newSelectedActions.map(function (selection) {
                return { actionId: selection.id, selectedOptions: selection.selectedOptions };
            }) }));
    };
    var selectFieldOption = function (selectedActionIndex, updatedField, selectedOption) {
        var updatedAction = selectedActions[selectedActionIndex];
        updatedAction.selectedOptions = updatedAction.selectedOptions || {};
        if (updatedAction.selectedOptions["".concat(updatedField.name)] === selectedOption.id) {
            return;
        }
        updatedAction.selectedOptions["".concat(updatedField.name)] = selectedOption.id;
        if (updatedField.hasSubField && "subField" in selectedOption) {
            var subFieldName = selectedOption.subField.name;
            if (subFieldName && updatedAction.selectedOptions[subFieldName]) {
                delete updatedAction.selectedOptions[subFieldName];
            }
        }
        setActionSelections(__spreadArray(__spreadArray(__spreadArray([], __read(selectedActions.slice(0, selectedActionIndex)), false), [
            updatedAction
        ], false), __read(selectedActions.slice(selectedActionIndex + 1)), false));
        onAutomationChange(__assign(__assign({}, currentAutomation), { actions: selectedActions.map(function (selection) {
                return { actionId: selection.id, selectedOptions: selection.selectedOptions };
            }) }));
    };
    var toggleOverwrite = function (actionIndex) {
        var actionToUpdate = selectedActions[actionIndex];
        actionToUpdate.overwrite = !actionToUpdate.overwrite;
        setActionSelections(__spreadArray(__spreadArray(__spreadArray([], __read(selectedActions.slice(0, actionIndex)), false), [
            actionToUpdate
        ], false), __read(selectedActions.slice(actionIndex + 1)), false));
    };
    var dropdownRef = react_1.default.createRef();
    var canAddMoreActions = function () {
        return (selectedActions.length < MAX_NUM_ACTIONS &&
            availableActions(triggersAndActions.actions, { selectedActions: selectedActions, selectedTrigger: selectedTrigger }).length !== 0);
    };
    var getAddButtonTooltip = function () {
        if (canAddMoreActions()) {
            return { content: "Add action", size: kaleidoscope_1.TooltipSize.Small };
        }
        else {
            return selectedActions.length === MAX_NUM_ACTIONS
                ? { content: "A maximum of three actions is allowed per automation", size: kaleidoscope_1.TooltipSize.Large }
                : { content: "No additional actions available", size: kaleidoscope_1.TooltipSize.Large };
        }
    };
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement("div", { className: styles.blocks },
            react_1.default.createElement("div", { className: styles.block },
                react_1.default.createElement("div", { className: styles.trigger },
                    react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.label }, "When"),
                    react_1.default.createElement(kaleidoscope_1.Select, { label: "Select a trigger", placeholder: "Select a trigger", value: selectedTrigger, labelHidden: true, autoStack: true, onChange: lodash_1.noop, icon: react_1.default.createElement(icons_1.Qwilr, null) }, triggersAndActions.triggers.map(function (trigger) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: trigger.id, value: trigger.id, onClick: function () { return selectTrigger(trigger); } }, trigger.label)); }))),
                react_1.default.createElement("div", { className: styles.actions },
                    selectedActions.map(function (selectedAction, index) {
                        var _a;
                        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.action, ((_a = selectedActions[index]) === null || _a === void 0 ? void 0 : _a.label) && styles.leftLine), key: index },
                            index == 0 ? (react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.label }, "Do this")) : (react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.label }, "And")),
                            react_1.default.createElement("div", { className: styles.actionBlock },
                                react_1.default.createElement("div", { className: styles.formWrapper },
                                    react_1.default.createElement(kaleidoscope_1.Select, { label: "Select an action", placeholder: "Select an action", value: selectedAction.id, labelHidden: true, autoStack: true, onChange: lodash_1.noop, icon: react_1.default.createElement(Icon, null) }, availableActions(triggersAndActions.actions, {
                                        selectedActions: selectedActions,
                                        selectedTrigger: selectedTrigger,
                                        includeAction: selectedAction,
                                    }).map(function (action) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: action.id, value: action.id, onClick: function () { return selectAction(action, index); } }, action.label)); })),
                                    selectedAction.form && (react_1.default.createElement(ActionForm, { selectedAction: selectedAction, selectedActionIndex: index, selectFieldOption: selectFieldOption, toggleOverwrite: toggleOverwrite, integrationTargetDisplayName: integrationTarget.displayName })),
                                    react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "xs" },
                                        react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "s" }, selectedAction.description && selectedAction.description))),
                                index > 0 && (react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.deleteActionButton, icon: react_1.default.createElement(icons_1.Delete, null), onClick: function () { return deleteAction(index); } })))));
                    }),
                    ((_a = selectedActions[selectedActions.length - 1]) === null || _a === void 0 ? void 0 : _a.label) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_1.Select, { label: "", value: "", ref: dropdownRef, labelHidden: true, autoStack: true, onChange: lodash_1.noop, className: styles.addActionDropdown }, availableActions(triggersAndActions.actions, { selectedActions: selectedActions, selectedTrigger: selectedTrigger }).map(function (action) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: action.id, value: action.id, onClick: function () {
                                addNewAction(action);
                            } }, action.label)); })),
                        react_1.default.createElement("div", { className: styles.addActionButtonWrapper },
                            react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Small, className: styles.addActionButton, icon: react_1.default.createElement(icons_1.Add, null), isRound: true, onClick: function () {
                                    dropdownRef.current.click();
                                }, disabled: !canAddMoreActions(), tooltip: getAddButtonTooltip() })))))))));
};
exports.AutomationsForm = AutomationsForm;
var availableActions = function (actions, _a) {
    var selectedActions = _a.selectedActions, selectedTrigger = _a.selectedTrigger, includeAction = _a.includeAction;
    return actions.filter(function (action) {
        return ((selectedTrigger ? action.supportedTriggers.includes(selectedTrigger) : true) &&
            (!includesAction(selectedActions, action.id) || (includeAction && action.id === includeAction.id)));
    });
};
var includesAction = function (actions, actionId) {
    return !!actions.find(function (_a) {
        var id = _a.id;
        return id === actionId;
    });
};
var createEmptySelectedActions = function () { return [
    {
        label: "",
        id: "",
        integration: "",
        supportedTriggers: [],
    },
]; };
var ActionForm = function (props) {
    var selectedAction = props.selectedAction, selectedActionIndex = props.selectedActionIndex, selectFieldOption = props.selectFieldOption, integrationTargetDisplayName = props.integrationTargetDisplayName;
    var MaybeWithTooltip = function (_a) {
        var show = _a.show, children = _a.children, _b = _a.tooltipMessage, tooltipMessage = _b === void 0 ? "" : _b;
        if (show) {
            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: tooltipMessage, size: kaleidoscope_1.TooltipSize.Large }, children));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    };
    var FormField = function (_a) {
        var formField = _a.formField, isDisabled = _a.isDisabled, disabledMessage = _a.disabledMessage, errorMessage = _a.errorMessage;
        return (react_1.default.createElement("div", { className: styles.formComponent, key: formField.name },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.formLabel }, (0, lodash_2.capitalize)(formField.label)),
            react_1.default.createElement(MaybeWithTooltip, { show: !!isDisabled && !!disabledMessage, tooltipMessage: disabledMessage },
                react_1.default.createElement(kaleidoscope_1.Select, { disabled: !!isDisabled, label: "Select a field", placeholder: "Select ".concat(formField.label), value: selectedAction.selectedOptions[formField.name], labelHidden: true, autoStack: true, onChange: lodash_1.noop, error: errorMessage }, formField.options.map(function (option, key) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: key, value: option.id, onClick: function () { return selectFieldOption(selectedActionIndex, formField, option); } }, option.label)); })))));
    };
    var getErrorMessage = function (field) {
        var _a, _b;
        return ((_a = selectedAction.selectedOptions) === null || _a === void 0 ? void 0 : _a[field.name]) &&
            !field.options.map(function (option) { return option.id; }).includes((_b = selectedAction.selectedOptions) === null || _b === void 0 ? void 0 : _b[field.name])
            ? "No longer exists in ".concat(integrationTargetDisplayName)
            : undefined;
    };
    var preSelectOption = function (field) {
        field.options.length === 1 && selectFieldOption(selectedActionIndex, field, field.options[0]);
    };
    var fields = [];
    if (selectedAction && selectedAction.form)
        selectedAction.form.map(function (field) {
            var _a;
            preSelectOption(field);
            switch (field.type) {
                case "dropdown":
                    var errorMessage = getErrorMessage(field);
                    fields.push(react_1.default.createElement(FormField, { formField: field, errorMessage: errorMessage }));
                    if (field.hasSubField) {
                        var selectedOptionId_1 = (_a = selectedAction.selectedOptions) === null || _a === void 0 ? void 0 : _a[field.name];
                        var selectedOption = field.options.find(function (option) { return option.id === selectedOptionId_1; });
                        if (!!selectedOptionId_1 && !!selectedOption) {
                            var subfieldErrorMessage = errorMessage ? undefined : getErrorMessage(selectedOption.subField);
                            fields.push(react_1.default.createElement(FormField, { formField: selectedOption.subField, errorMessage: subfieldErrorMessage }));
                        }
                        else {
                            fields.push(react_1.default.createElement(FormField, { formField: field.options[0].subField, isDisabled: true, disabledMessage: "Select ".concat(field.label, " first") }));
                        }
                    }
                    break;
            }
        });
    return (react_1.default.createElement("div", { className: styles.actionForm },
        react_1.default.createElement("div", { className: styles.fieldWrapper }, fields)));
};
